import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useSectors } from '@/hooks/v1';
import { toOptions } from '@/views/Bera/_components/Filter/utils';
import { useApplicationContext } from '@/context/v1/Application/context';
import { HierarchySelect } from '@/views/Bera/_components/Filter/Fields/HierarchySelect';

import type { BeraFilterFormFields } from '@/views/Bera/types';

const { useFormInstance, useWatch } = Form;

export function Sector(): JSX.Element {
	const form = useFormInstance<BeraFilterFormFields>();
	const { organization } = useApplicationContext();

	const companyId = useWatch('company_id_filter', form);

	const {
		data: sectors,
		isLoading,
		isFetching,
		isError
	} = useSectors({
		organizationId: organization?.id,
		companyId
	});

	function handleChange(): void {
		const clearedFields = { line_id: undefined, workstation_id: undefined };

		form.setFieldsValue(clearedFields);
	}

	return (
		<Col xs={24}>
			<Form.Item name="sector_id" label={I18n.get('Sector')} labelCol={{ span: 24 }}>
				<HierarchySelect
					onChange={handleChange}
					loading={isFetching}
					options={toOptions(sectors)}
					placeholder={I18n.get('Sector')}
					disabled={isLoading || isFetching || isError || !companyId}
				/>
			</Form.Item>
		</Col>
	);
}
